import React, { useEffect, useState } from "react";
import classNames from "classnames";
import * as Icons from "Components/Icons";
import { IVenueSearchResult, IWorkspaceSearchResult, SearchGeofence } from "Services/API/API";

export interface MapTooltipProps {
   venue: IVenueSearchResult,
   isLinkDisabled?: boolean
}

export const MapTooltip: React.FC<MapTooltipProps> = function ({ venue, isLinkDisabled = false }) {
   const index = 0;

   const [currentWorkspaceIndex, setCurrentWorkspaceIndex] = useState<number>(index);
   const [currentWorkspace, setCurrentWorkspace] = useState<IWorkspaceSearchResult>();

   const onNextWorkspace = (e) => {
      e.preventDefault();
      if (venue.workspaceSearchResults && currentWorkspaceIndex + 1 < venue.workspaceSearchResults?.length) {
         setCurrentWorkspace(venue.workspaceSearchResults[currentWorkspaceIndex + 1]);
         setCurrentWorkspaceIndex(currentWorkspaceIndex + 1);
      }
   }

   const onPrevWorkspace = (e) => {
      e.preventDefault();
      if (venue.workspaceSearchResults && currentWorkspaceIndex - 1 >= index) {
         setCurrentWorkspace(venue.workspaceSearchResults[currentWorkspaceIndex - 1]);
         setCurrentWorkspaceIndex(currentWorkspaceIndex - 1);
      }
   }

   useEffect(() => {
      if (venue.workspaceSearchResults) {
         setCurrentWorkspace(venue.workspaceSearchResults[index]);
      }
   }, []);

   return (<>
      <div className="map-tooltip">
         <div className="map-tooltip-workspace">
            <div className="map-tooltip-workspace-image-wrapper" style={{ backgroundImage: `url(${currentWorkspace?.imgUrl || venue.imageUrl}`, backgroundPosition: "center", backgroundSize: "cover" }}>
               {
                  venue.workspaceSearchResults && venue.workspaceSearchResults?.length > 1
                     ? <a href="#" className="map-tooltip-workspace-image-previous font-icon" onClick={onPrevWorkspace}><Icons.ArrowLeft size="32" /></a>
                     : ""
               }
               <a className={classNames("map-tooltip-workspace-image", { "disabled": isLinkDisabled })} target="_blank" href={currentWorkspace?.url}></a>
               {
                  venue.workspaceSearchResults && venue.workspaceSearchResults?.length > 1
                     ? <a href="#" className="map-tooltip-workspace-image-next font-icon" onClick={onNextWorkspace}><Icons.ArrowRight size="32" /></a>
                     : ""
               }
               {
                  venue.workspaceSearchResults && venue.workspaceSearchResults?.length > 1
                     ? <span className="map-tooltip-workspaces-counter"><span>{currentWorkspaceIndex + 1}</span> of <span>{venue.workspaceSearchResults?.length}</span> workspaces</span>
                     : ""
               }
            </div>
            <div className="map-tooltip-workspace-details">
               <div className="map-tooltip-workspace-prices">
                  {
                     currentWorkspace?.priceAmount
                        ? <span>{currentWorkspace?.priceAmount}{currentWorkspace?.priceDescription}</span>
                        : <span>FREE</span>
                  }

               </div>
               {
                  venue.url
                     ? <a className={classNames("map-tooltip-venue-name", { "disabled": isLinkDisabled })} href={venue.url} target="_blank">{venue.name}</a>
                     : <span className="map-tooltip-venue-name">{venue.name}</span>
               }
               <a className={classNames("map-tooltip-workspace-name", { "disabled": isLinkDisabled })} href={currentWorkspace?.url} target="_blank">{currentWorkspace?.name}</a>               
            </div>
         </div>
      </div>
      <div className="map-tooltip-extender"></div>
   </>);
}

interface MapGeofenceTooltipProps {
   hq: SearchGeofence;
}
export const MapGeofenceTooltip: React.FC<MapGeofenceTooltipProps> = ({ hq }) => {
   return <>
      <div className="map-tooltip">
         <div className="map-tooltip-workspace">
            <div className="map-tooltip-workspace-image-wrapper" style={{ backgroundImage: `url(${hq.imageUrl}`, backgroundPosition: "center", backgroundSize: "cover" }}>
               <a className={classNames("map-tooltip-workspace-image")} target="_blank" href={hq.venueUrl}></a>
            </div>
            <div className="map-tooltip-workspace-details">
               {
                  hq.venueUrl
                     ? <a className={classNames("map-tooltip-venue-name")} href={hq.venueUrl} target="_blank">{hq.venueName}</a>
                     : <span className="map-tooltip-venue-name">{hq.venueName}</span>
               }
               <span className="map-tooltip-workspace-name">{hq.venueAddress}</span>
            </div>
         </div>
      </div>
      <div className="map-tooltip-extender"></div>
   </>
}